import React from 'react';
import {InvoiceTransactionVO} from "../../../types/model/valueObject/invoice/InvoiceTransactionVO";
import {SupplierInvoicesCardListItem} from "./SupplierInvoicesCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type SupplierInvoicesCardListProps = {
  items?: InvoiceTransactionVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const SupplierInvoicesCardList = ({
  items,
  expandByIndex,
  onToggleExpand,
}: SupplierInvoicesCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <SupplierInvoicesCardListItem
          key={item.transactionId}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const SupplierInvoicesCardListWithLoader = withLoader(SupplierInvoicesCardList, skeletonLoader);

export {
  SupplierInvoicesCardList,
  SupplierInvoicesCardListWithLoader
};
